import {destroyCookie} from 'nookies';
import {
  cookieApiRefreshTokenKey,
  cookieApiTokenKey,
  cookieSessionKey,
} from '../../../server/token';
import {
  cookieSessionIdKey,
  cookieUserIdKey,
} from '../../../server/token/cookieUserInfoKey';
import {discardInFlightRefresh} from './refreshAccessTokenWithLock';
import {advanceSessionEpoch} from './sessionEpoch';

export const destroyCookieWithLogout = () => {
  // 実行中のリフレッシュが完了後にトークンを書き戻すのを防ぐ
  advanceSessionEpoch();
  discardInFlightRefresh();

  const cookiesToDelete = [
    cookieApiTokenKey,
    cookieApiRefreshTokenKey,
    cookieSessionKey,
    cookieSessionIdKey,
    cookieUserIdKey,
  ];

  for (const cookieKey of cookiesToDelete) {
    try {
      destroyCookie(null, cookieKey, {path: '/'});
    } catch (error) {
      console.error(`Failed to delete cookie: ${cookieKey}`, error);
    }
  }
};
